import { api } from '@/apis';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useDeleteUserQuery() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => {
      if (id) {
        return api.delete(`userQueries/${id}`);
      }
    },
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ['userQueries'] }),
  });
}
